@for (line of arrayOfLines; track $index) {
  <ng-container *ngTemplateOutlet="skeletonLoadingCard"></ng-container>
}
<ng-template #skeletonLoadingCard>
  <div class="card shadow-sm mt-3" wlAutomationId="skeleton">
    <div class="card-body pb-lg-3">
      <div class="w-75 h-font-size mb-1">
        <div class="skeleton bg-light"></div>
      </div>
      <div class="w-90 h-font-size mb-3 mb-lg-6">
        <div class="skeleton bg-light"></div>
      </div>
    </div>
  </div>
</ng-template>
